import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { brandImage, testimonials } from '@/mocks/home';
import { btn } from '@/lib/ui';

const principles = [
  '只呈现有信息量的现场，不用标题党换取点击',
  '画质优先，宁可清晰度保守，也不过度插值失真',
  '热点快速跟进，同时保留事实核对的时间',
];

const BrandSection = () => (
  <section id="about" className="border-t border-background-200 bg-background-100 py-16 md:py-24">
    <div className="mx-auto w-full max-w-shell px-4 md:px-8">
      <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
        <Reveal>
          <div className="relative">
            <div className="h-72 w-full overflow-hidden rounded-lg md:h-[420px]">
              <img
                src={brandImage}
                alt="看料社团队内容编辑空间，专注内容质量与播放体验"
                title="看料社 - 专注极速超清观看体验"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-5 right-4 w-44 rounded-lg border border-background-200 bg-background-50 p-4 md:right-6 md:w-52">
              <p className="font-heading text-2xl font-semibold text-primary-600 md:text-3xl">6 年</p>
              <p className="mt-1 text-[11px] leading-relaxed text-foreground-600 md:text-xs">
                专注热门内容聚合与播放体验优化
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <SectionHeading
            kicker="关于我们"
            title="把「看得顺」当成一件正经事来做"
            desc="看料社由一个专注内容聚合与播放优化的小团队维护。我们相信，热门内容值得被更顺畅地看见，而不是把时间浪费在缓冲与等待上。"
          />
          <ul className="mt-6 flex flex-col gap-3">
            {principles.map((item) => (
              <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-foreground-700 md:text-base">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-800">
                  <i className="ri-check-line text-sm" />
                </span>
                {item}
              </li>
            ))}
          </ul>
          <Link to="/about" className={`${btn('outline', 'md')} mt-8`}>
            了解我们的内容原则
            <i className="ri-arrow-right-line" />
          </Link>
        </Reveal>
      </div>

      <div className="mt-16 grid gap-5 md:grid-cols-3 md:gap-6">
        {testimonials.map((person, index) => (
          <Reveal key={person.name} delay={index * 90}>
            <figure className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                <i className="ri-double-quotes-l text-base" />
              </span>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                {person.quote}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="h-10 w-10 overflow-hidden rounded-full">
                  <img src={person.avatar} alt={`${person.name}的头像`} title={person.name} className="h-full w-full object-cover object-top" />
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-950">{person.name}</span>
                  <span className="block text-[11px] text-foreground-500">{person.role}</span>
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default BrandSection;